import { useState } from "react";
import { Container, Modal } from "react-bootstrap";

import "./DEAModal.styles.scss";
import logo from "../../../Assets/project-icon.svg";
import download2 from "../../../Assets/download2.svg";

import FilePicker from "../../../util/file-picker/FilePickerv2";
import Close from "../../../Assets/close.svg";
import PrimaryButton from "../../../util/Btns/PrimaryButton";
import { useUploadDEA } from "../../../hooks/DevProjectHooks";
import ConsoleLocalStorage from "../../../storage/storage.js";

const DEAModal = ({ showDEA, setShowDEA, projectid }) => {
  const handleClose = () => setShowDEA(false);
  const [DEAfile, setDEAfile] = useState();
  const [apkUpload, setApkUpload] = useState(false);
  const { mutate } = useUploadDEA(projectid, DEAfile, setShowDEA);
  const handleSubmit = async () => {
    mutate();
  };
  
 

  return (
    <>
      <Container>
        <Modal
          show={showDEA}
          onHide={handleClose}
          centered
          contentClassName={"DEA"}
          dialogClassName="mah_modal"
        >
          <Modal.Header className="title_modal_header">
            <Modal.Title>
              <img
                src={logo}
                alt="logo"
                style={{ marginRight: "0.25em" }}
                className="console_card_img"
              />
              <span
                style={{
                  fontFamily: "JioType-Medium",
                  fontSize: "medium",
                  marginBottom: "3em",
                }}
              >
                Developer Evaluation Agreement
              </span>
            </Modal.Title>
            <img
              onClick={() => setShowDEA(false)}
              src={Close}
              height="14"
              width="14"
              style={{ marginTop: "10px" }}
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>
          <Modal.Body>
            <div className="DEA_body">
              <div className="DEA_body_container">
                <h5>
                  Step 1: Download the Developer Evaluation Agreement (DEA) from
                  below
                </h5>
                <div className="text-center download_DEA width-full-mobile">
                  <a href={ConsoleLocalStorage.getOrganization().type==="organization"?`https://tess-blob-cdn.azureedge.net/dc-documents/DEACompanies.docx`:`https://tess-blob-cdn.azureedge.net/dc-documents/DEAIndividuals.docx`}>
                  <h6 className="">
                    <img
                      src={download2}
                      alt="logo"
                      className="fluid logo"
                      style={{
                        width: "1rem",
                        height: "1rem",
                        marginRight: "0.5rem",
                      }}
                    />
                    {/* <DownloadLink
                    label="Download DEA"
                    filename="fileName.txt"
                    exportFile={() => download2}
                  /> */}
                    <a
                      className="download_DEA_link"
                      href={ConsoleLocalStorage.getOrganization().type==="organization"?`https://tess-blob-cdn.azureedge.net/dc-documents/DEACompanies.docx`:`https://tess-blob-cdn.azureedge.net/dc-documents/DEAIndividuals.docx`}
                    >
                      Download DEA
                    </a>
                  </h6>
                  </a>
                </div>
              </div>
              <div className="DEA_body_container">
                <h5>Step 2: Please sign it and upload it below</h5>
                <div className="filepicker_DEA">
                  <FilePicker
                    text="Upload DEA here"
                    onComplete={(data) => {setDEAfile(data)
                    if(data.url !== "")
                      setApkUpload(true);
                    else
                      setApkUpload(false);
                    }}
                    showplus={true}
                    fileTypeCheck={".pdf,.PDF"}
                  />
                </div>
                <span className="text-gray font-size-12 font-bold">Note: Only PDF format is supported.</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1em",
              }}
              className=""
            >
              <PrimaryButton onClick={handleSubmit} disabled={!apkUpload}>Submit</PrimaryButton>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default DEAModal;
